var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditSurveyOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1353_49996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.5 24C47.5 36.9787 36.9787 47.5 24 47.5C11.0213 47.5 0.5 36.9787 0.5 24C0.5 11.0213 11.0213 0.5 24 0.5C36.9787 0.5 47.5 11.0213 47.5 24Z",
    stroke: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.048 34.512L33.024 21.264H34.512V34.56C34.512 34.96 34.368 35.296 34.08 35.568C33.792 35.856 33.448 36 33.048 36H12V14.952C12 14.552 12.136 14.208 12.408 13.92C12.696 13.632 13.04 13.488 13.44 13.488H26.736V14.976H13.44L13.488 34.512H33.048ZM21.48 25.464L22.968 23.952L24.048 25.032L22.536 26.52L21.48 25.464ZM34.944 12L36 13.056L25.128 23.928L24.072 22.872L30.744 16.2L31.488 15.432L33 13.944L34.944 12Z",
    fill: "#A3A3A3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1353_49996"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditSurveyOutline);
export default __webpack_public_path__ + "static/media/edit-survey-outline.5b3c765620e039eedb0fffc3bb246b07.svg";
export { ForwardRef as ReactComponent };